import React from 'react';
import { useLocation } from 'react-router-dom';
import FitnessProfileQuestionnairePage from './FitnessProfileQuestionnairePage';

export default function FitnessProfileCreatePage() {
	const location = useLocation();

	return <FitnessProfileQuestionnairePage key={location.key} />;
}
